import React from 'react';

type WaveIndicatorProps = {
  active?: boolean;
  className?: string;
};

const BAR_COUNT = 20;

const WaveIndicator: React.FC<WaveIndicatorProps> = ({ active = false, className = '' }) => {
  return (
    <div className={`praxys-wave-indicator${active ? ' active' : ''}${className ? ` ${className}` : ''}`} aria-hidden="true">
      {Array.from({ length: BAR_COUNT }).map((_, idx) => (
        <span key={idx} style={{ animationDelay: `${idx * 0.07}s` }} />
      ))}
    </div>
  );
};

export default WaveIndicator;
